import { render, staticRenderFns } from "./DonoutSemaforo.vue?vue&type=template&id=70b6f926"
import script from "./DonoutSemaforo.vue?vue&type=script&lang=js"
export * from "./DonoutSemaforo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports